import {
  CustomUploadResponse,
  IStyles,
  IconWrapper,
  ImageWrapper,
  LinkButton,
  Loader,
  MarksSubmitPopup,
  NoContentCard,
  PrimaryButton,
  ScoreProgressBar,
  convertPercentageToMarks,
  deserify,
  getFileExtensionType,
  getFileSizeInMB,
  getFileType,
  getLocalStorage,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  theme,
  uploadFile,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import {
  CloudUpload,
  AssignmentConfigEnum,
  SubmissionType,
} from '@protos/learning_management/lms.db_pb';
import { ModeOfConductionEnum } from '@protos/learning_management/lms.db_pb';
import {
  StudentPerformanceInfo,
  StudentSubmissionInfo,
} from '@protos/learning_management/lms.hw.teacher.apis_pb';
import { ChangeEvent, DragEvent, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../../app/Context/GlobalContextProvider';
import { useAppDispatch, useAppSelector } from '../../../reduxStore/reduxHooks';
import {
  ASSESSMENT_VIEW,
  HOME,
  HOMEWORK_COMPLETED,
  HOMEWORK_MANAGE,
  HOMEWORK_PERFORMANCE,
  HOMEWORK_SUBMISSION_CUSTOM,
} from '../../../routeHandling/RoutesNomenclature';
import { isTimeLeft } from '../manageHWutils';
import { interactionEvent } from '../../Auth/auth.events';
import {
  setToastInfo,
  setToastInfoV2,
} from '../../Home/reducer/homeDashboard.slice';
import {
  aiHomeworkCloseEvent,
  aiHomeworkOpenEvent,
} from '../../Homework/homework.events';
import { setCurrentAssessmentClassStats } from '../reducer/manageHomework.slice';
import { StudentSection } from './components/StudentSection';
import { HwDetails } from './components/hwDetails';
import { useDownloadContext } from '../../../app/Context/DownloadContextProviderV2';
import {
  AssessmentContent,
  AssessmentTask,
} from '@protos/learning_management/lms.assessment.common.apis_pb';
import { TeacherOmrAssessmentClassStats } from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { OmrUploadPopup } from '../../Assessment/OmrAssessment/OmrActive/components/OmrUploadPopup';
import { CustomUploadFileResponse } from '../../Assessment/reducer/assessmentFlow.slice';
import {
  FileUploadPurpose,
  MimeEnum,
  SignedUrlReponse,
} from '@protos/learning_management/lms.common.apis_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { Timestamp } from '@bufbuild/protobuf';
import { SectionStudent } from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { StudentListPopup } from '../../Assessment/Common/AssignAssessment/components/StudentListPopup';
import { useAttendanceFeatureEnabled } from '../../../utils/customHooks';
import { OverviewBox } from '../../../components/OverviewBox';

const styles: IStyles = {
  root: {
    width: '100%',
    padding: {
      md: `${pxTovW(15)} ${pxTovW(20)}`,
      lg: `${pxTovW(15)} ${pxTovW(240)}`,
    },
    paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    boxSizing: 'border-box',
    overflowX: 'hidden',
  },
  header: {
    width: '100%',
    display: 'flex',

    gap: { xs: pxToRem(10), md: pxTovW(22) },
    alignItems: 'center',
  },
  headImage: {
    width: { xs: pxToRem(74), md: pxToRem(50), lg: pxTovW(124) },
    height: { xs: pxToRem(74), md: pxToRem(50), lg: pxTovW(124) },
    borderRadius: { xs: pxToRem(6), md: pxToRem(6), lg: pxTovW(15) },
    objectFit: 'cover',
  },
};

export interface ISubmissionProps {
  studentData?: StudentPerformanceInfo;
  marks?: number;
  checkedValue?: boolean;
}
interface IStudentStatus {
  studentId: bigint;
  isSubmitted?: boolean;
  marks?: number;
}

export interface IStatusObj {
  [key: string]: IStudentStatus;
}
export const OngoingHomework = () => {
  // const { homework_id } = useParams();
  const navigate = useNavigate();
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const [marksPopupDisplay, setMarksPopupDisplay] = useState(false);
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const isAttendanceFeatureEnabled = useAttendanceFeatureEnabled();
  const [studentListPopupOpen, setStudentListPopupOpen] = useState(false);
  const {
    assessment_list_data,
    current_assessmemt_classStats,
    selected_assessment_id,
  } = deserify(useAppSelector((state) => state.manageHomework));
  const { selected_live_quiz_attempt } = deserify(
    useAppSelector((state) => state.manageHomework)
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [studentInfo, setStudentInfo] = useState<
    StudentPerformanceInfo | undefined
  >();
  const [sectionStudentInfo, setSectionStudentInfo] = useState<
    SectionStudent[]
  >([]);
  const { isIpadOnly } = useGlobalContext();

  //array to store isSubmitted values locally

  const dispatch = useAppDispatch();
  const [currentHomwork, setCurrentHomwork] = useState<AssessmentTask>();
  const {
    LmsHomewokTeacherAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler,
    SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler,
    LmsCommonAPIServiceV2ClientWithStatusCodeHandler,
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const teacher_id = getLocalStorage('userId');
  const { setSelectedFunction } = useGlobalContext();
  const { class_subject_info } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  const [sectionList, setSectionList] = useState<
    { name: string; id: bigint; selected: boolean }[]
  >(
    user_info?.teachClassSubjects
      ?.filter((elem) => class_subject_info?.classId === elem.classId)
      .map((elem) => ({
        id: elem.sectionId,
        name: elem.sectionName,
        selected: true,
      })) || []
  );

  const [StatusObject, updateStatusObject] = useState<IStatusObj | undefined>();
  const [omrClassStats, setOmrClassStats] = useState<
    TeacherOmrAssessmentClassStats | undefined
  >();
  const [openOmrUploadPopup, setOpenOmrUploadPopup] = useState(false);
  const [omrScanFile, setOmrScanFile] = useState<
    CustomUploadResponse[] | undefined
  >();
  const [assessmentContent, setAssessmentContent] = useState<
    AssessmentContent | undefined
  >();

  // -----------------------------------------------------

  const getOMRAssessmentClassStats = async (homeworkId: bigint) => {
    try {
      const response =
        await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.getOmrAssessmentClassStats(
          { assessmentId: homeworkId }
        );
      if (response.data) {
        setOmrClassStats(response.data);
      } else {
        throw new Error('No data found');
      }
    } catch (error) {
      throw new Error('Error fetching OMR assessment class stats');
    }
  };

  // -----------------------------------------------------

  const fetchAssessmentContent = async () => {
    try {
      // setLoading('loading');
      const response =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: teacher_id,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: selected_assessment_id,
          }
        );
      if (response.data) {
        setAssessmentContent(response.data);
      }

      // setLoading('completed');
    } catch (err) {
      console.error(err);
      // setLoading('error');
    } finally {
      // setLoading('completed');
    }
  };

  // -----------------------------------------------------

  const getHomeworkDetails = async (homeworkId: bigint) => {
    try {
      setLoading(true);
      const response =
        await LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler.getAssessmentClassStats(
          {
            assessmentId: homeworkId,
            attemptNumber: selected_live_quiz_attempt
              ? selected_live_quiz_attempt
              : undefined,
          }
        );
      if (response.data) {
        let classStatsData: any = response.data;
        if (
          response.data.assessment?.modeOfConduction ===
          ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
        ) {
          // it is added here as assessment details are not coming in getOmrAssessmentClassStats
          await getOMRAssessmentClassStats(homeworkId);
        }
        const sectionListNew =
          user_info?.teachClassSubjects
            ?.filter(
              (elem) =>
                response?.data?.assessment?.classId === elem.classId &&
                response?.data?.assessment?.sectionId === elem.sectionId
            )
            .map((elem) => ({
              id: elem.sectionId,
              name: elem.sectionName,
              selected: true,
            })) || [];
        setSectionList(sectionListNew);
        // console.log(response.data);
        const StatusObj: IStatusObj = {};
        classStatsData.studentPerformanceInfo.forEach(
          (e: StudentPerformanceInfo) => {
            const id = e.studentId.toString();
            StatusObj[id] = {
              studentId: e.studentId,
              isSubmitted: e.isSubmitted || false,
              marks: convertPercentageToMarks(
                e.scorePercent,
                classStatsData?.assessment?.maxMarks
              ),
            };
          }
        );
        updateStatusObject(StatusObj);
        await aiHomeworkOpenEvent({
          homeworkId: selected_assessment_id,
          isOffline: isOffline,
        });
        dispatch(setCurrentAssessmentClassStats(classStatsData));
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      setError(true);
      console.log(err);
    }
  };

  // -----------------------------------------------------

  const markAttendanceOnClose = async (props: {
    selectedStudents: SectionStudent[];
    allStudents: any[];
  }) => {
    console.log({ props });
    if (!selected_assessment_id) return;
    const selectedSet = new Set(
      props.selectedStudents.map((student) => student.studentId.toString())
    );

    const attendance = props.allStudents.map((student) => ({
      studentId: student.studentId,
      isPresent: selectedSet.has(student.studentId.toString()),
    }));

    if (!attendance.length) return;

    try {
      setLoading(true);
      await LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler.markAttendance(
        {
          teacherId: BigInt(teacher_id),
          assessmentId: selected_assessment_id,
          attendance,
        }
      );
      dispatch(
        setToastInfo({
          label: 'Attendance updated successfully',
          variant: 'success',
          open: true,
        })
      );
    } catch (err) {
      dispatch(
        setToastInfo({
          label: 'Failed to update attendance',
          variant: 'error',
          open: true,
        })
      );
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const physicalHwSubmitHandler = async (props: ISubmissionProps) => {
    const { checkedValue, marks, studentData } = props;
    //if max marks are there student data is taken from student info because in that case a pop up is needed which requires that data but if maxmarks are not present
    //then whole operation is to be done on radio button click , so data cannot be taken form local variable
    if (!studentInfo && !studentData) {
      return;
    }
    const studentPerformaceData = studentInfo || studentData;
    const isSubmittedStatus = marks !== undefined ? true : checkedValue;
    if (marks !== undefined) {
      const regex = /^\d+$/;
      if (!regex.test(marks.toString())) {
        dispatch(
          setToastInfo({
            label: 'Marks can be whole numbers only',
            variant: 'error',
            open: true,
          })
        );
        return;
      }
    }
    try {
      setLoading(true);
      const submissionsInfo = new StudentSubmissionInfo({
        studentId: studentPerformaceData?.studentId,
        isSubmitted: isSubmittedStatus,
      });
      if (isSubmittedStatus && marks !== undefined) {
        submissionsInfo.obtainedMarks = marks;
      }
      const response =
        await LmsHomewokTeacherAPIServiceV1ClientWithStatusCodeHandler.studentHWPhysicalSubmissionUpdate(
          {
            teacherId: BigInt(teacher_id),
            homeworkId: selected_assessment_id,
            submissionsInfo: [submissionsInfo],
            maxMarks: current_assessmemt_classStats?.assessment?.maxMarks || 0,
          }
        );
      if (response) {
        console.log('response PhysicalHwSubmitHandler', response);
        const id = studentPerformaceData?.studentId.toString();
        //making changes in local status obj
        if (id && StatusObject && StatusObject[id]) {
          StatusObject[id].marks = marks;
          StatusObject[id].isSubmitted = isSubmittedStatus; //changing the status
        }

        updateStatusObject(StatusObject);
        selected_assessment_id && getHomeworkDetails(selected_assessment_id);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // -----------------------------------------------------

  const cardOnClick = (studentId: string) => {
    const modifiedId = String(studentId).split(' - ')[1];
    const pathStudentId = modifiedId || '0';

    const omrMode =
      current_assessmemt_classStats?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR;
    const isLiveQuiz =
      current_assessmemt_classStats?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_WEB_LIVE;
    // setMarksPopupDisplay(true);
    // navigate(`${HOMEWORK_SUBMISSION_CUSTOM}/${studentId}`);
    const student = StatusObject && StatusObject[studentId.toString()];
    switch (current_assessmemt_classStats?.assessment?.submissionType) {
      case SubmissionType.SUBMISSION_OFFLINE:
        // if (current_assessmemt_classStats.homework.maxMarks) {
        //   setMarksPopupDisplay(true);
        // }
        //replaced with marksTextClickHandler as per new reqs
        break;
      case SubmissionType.SUBMISSION_ONLINE:
        if (student?.isSubmitted) {
          navigate(`${HOMEWORK_SUBMISSION_CUSTOM}/${studentId}`);
        }
        break;
      default:
        omrMode
          ? navigate(
              `${HOMEWORK_PERFORMANCE}/${pathStudentId}?omrMode=true&omrStudentId=${encodeURIComponent(
                studentId
              )}`
            )
          : navigate(
              `${HOMEWORK_PERFORMANCE}/${studentId}${
                isLiveQuiz && selected_live_quiz_attempt !== undefined
                  ? `?attemptNumber=${selected_live_quiz_attempt}`
                  : ''
              }`
            );
    }
  };

  // -----------------------------------------------------

  const marksTextClickHandler = (student: StudentPerformanceInfo) => {
    setStudentInfo(student);
    if (
      current_assessmemt_classStats?.assessment?.submissionType ===
      SubmissionType.SUBMISSION_OFFLINE
    ) {
      if (current_assessmemt_classStats.assessment.maxMarks) {
        setMarksPopupDisplay(true);
      }
    }
  };

  // -----------------------------------------------------

  const classSection = [
    current_assessmemt_classStats?.assessment?.class,
    current_assessmemt_classStats?.assessment?.section,
  ]
    .filter(Boolean)
    .join('');

  const subtitleParts = [
    classSection,
    current_assessmemt_classStats?.assessment?.subject,
    current_assessmemt_classStats?.assessment?.moduleName,
  ]
    .filter(Boolean)
    .join(' | ');

  // -----------------------------------------------------

  const getStudentsSubmissionCount = () => {
    if (
      current_assessmemt_classStats?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      return omrClassStats?.studentPerformanceInfo?.filter(
        (student) => student.isSubmitted
      )?.length;
    }
    return current_assessmemt_classStats?.studentsSubmissionCount;
  };

  // -----------------------------------------------------

  const getAssignedStudentsCount = () => {
    if (
      current_assessmemt_classStats?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      return omrClassStats?.studentPerformanceInfo?.length;
    }
    return current_assessmemt_classStats?.studentPerformanceInfo?.length;
  };

  // -----------------------------------------------------

  const getStudentPerformanceInfoList = () => {
    if (
      current_assessmemt_classStats?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      return omrClassStats?.studentPerformanceInfo;
    }
    return current_assessmemt_classStats?.studentPerformanceInfo;
  };

  // -----------------------------------------------------

  const handleDropFunction = async (event: DragEvent<HTMLDivElement>) => {
    await uploadStudentData(event.dataTransfer.files);
  };

  const handleChangeFunction = async (event: ChangeEvent<HTMLInputElement>) => {
    await uploadStudentData(event.target.files as FileList);
    // Reset input value so selecting the same file again triggers onChange
    if (event.target) event.target.value = '';
  };

  const handleDeleteFunction = async (indexToDelete: number) => {
    // if (!custom_resource_data) return;
    // const tempUserUploads = [
    //   ...custom_resource_data.custom_resource_uploaded_files,
    // ];
    // tempUserUploads[indexToDelete].uploadFileData.isDeleted = true;
    // dispatch(
    //   setCustomResourceData({
    //     ...custom_resource_data,
    //     custom_resource_uploaded_files: tempUserUploads,
    //   })
    // );
    setOmrScanFile(undefined);
  };

  // -----------------------------------------------------

  const hasSuccessfulUpload = omrScanFile?.some(
    (upload) =>
      !upload.uploadFileData.isDeleted && upload.fileUploadStatus === 'success'
  );

  // -----------------------------------------------------

  const uploadStudentData = async (filesToUpload: FileList) => {
    if (!filesToUpload?.length) return;

    if (filesToUpload.length > 1) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: 'Only one file can be uploaded at a time.',
          open: true,
        })
      );
      return;
    }

    const selectedFile = filesToUpload[0];
    if (!selectedFile) return;

    if (hasSuccessfulUpload) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: 'Only one file can be added at a time.',
          open: true,
        })
      );
      return;
    }

    if (
      ![
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].includes(selectedFile.type)
    ) {
      dispatch(
        setToastInfoV2({
          label: 'Please upload a valid Excel file (.xls or .xlsx)',
          variant: 'error',
          open: true,
        })
      );

      return;
    }

    const tempUserUploads: CustomUploadFileResponse = {
      uploadFileData: new CloudUpload({
        gcpFileUrl: '',
        personId: user_info?.teacherProfileId,
        fileSizeInMb: getFileSizeInMB(selectedFile.size),
        isDeleted: false,
        fileName: selectedFile.name,
        fileType: getFileType(selectedFile.type),
        fileExtensionType: getFileExtensionType(selectedFile.type),
        isUploaded: false,
        signedUrl: '',
      }),
      fileUploadStatus: 'pending',
      fileSize: selectedFile.size,
    };

    setOmrScanFile([tempUserUploads]);

    try {
      setLoading(true);

      const signedUrlResponse: SignedUrlReponse =
        await LmsCommonAPIServiceV2ClientWithStatusCodeHandler.getSignedUrlForFileUpload(
          {
            personId: BigInt(teacher_id),
            filesInfo: [
              {
                originalFilePath: selectedFile.name,
                mimeType: MimeEnum.MIME_XLSX,
                size:
                  getFileSizeInMB(selectedFile.size) < 0.01
                    ? 0.01
                    : getFileSizeInMB(selectedFile.size),
              },
            ],
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            fileUploadPurpose: FileUploadPurpose.FILE_UPLOAD_FOR_OMR_IMPORT,
            schoolId: user_info?.schoolDetails[0]?.schoolId,
          }
        );

      if (signedUrlResponse && signedUrlResponse.response.length > 0) {
        tempUserUploads.uploadFileData.signedUrl =
          signedUrlResponse.response[0].signedUrl;
        const signedUrl = getMediaBasePath(
          signedUrlResponse.response[0].signedUrl
        );
        const uploadSuccess = await uploadFile({
          file: selectedFile,
          signedUrl,
        });
        if (uploadSuccess.success === true) {
          // If upload is successful, update status to 'success'
          tempUserUploads.uploadFileData.gcpFileUrl =
            signedUrlResponse.response[0].signedUrl;
          tempUserUploads.uploadFileData.isUploaded = true;
          tempUserUploads.fileUploadStatus = 'success';
          setOmrScanFile([tempUserUploads]);
          const uploadExcelResponse =
            await SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler.importOmrResponsesFromExcel(
              {
                assessmentId: selected_assessment_id,
                filesInfo: [tempUserUploads.uploadFileData],
                // dateOfAssessment:
                dateOfAssessment: Timestamp.fromDate(
                  new Date('2026-05-14T10:30:00Z')
                ),
              }
            );
          setOmrScanFile([]);
          setOpenOmrUploadPopup(false);
          dispatch(
            setToastInfoV2({
              variant: 'success',
              label: 'OMR responses imported successfully',
              open: true,
            })
          );
          // await getClassStats();
          if (selected_assessment_id) {
            await getHomeworkDetails(selected_assessment_id);
          }
        } else {
          tempUserUploads.uploadFileData.isUploaded = false;
          tempUserUploads.fileUploadStatus = 'Upload Error';
          setOmrScanFile([]);
        }
        // if (uploadSuccess.success === true) {
        //   tempUserUploads.uploadFileData.gcpFileUrl =
        //     signedUrlResponse.response[0].signedUrl;
        //   tempUserUploads.uploadFileData.isUploaded = true;
        //   tempUserUploads.fileUploadStatus = 'success';
        //   setOmrScanFile([tempUserUploads]);

        //   const uploadExcelResponse =
        //     await SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler.importOmrResponsesFromExcel(
        //       {
        //         assessmentId: Number(assessment_id),
        //         filePath: signedUrlResponse.response[0].signedUrl,
        //         // dateOfAssessment:
        //         dateOfAssessment: Timestamp.fromDate(
        //           new Date('2026-05-14T10:30:00Z')
        //         ),
        //       }
        //     );

        //   console.log('uploadExcelResponse:', uploadExcelResponse);
        // } else {
        //   tempUserUploads.uploadFileData.isUploaded = false;
        //   tempUserUploads.fileUploadStatus = 'Upload Error';
        //   setOmrScanFile([tempUserUploads]);
        // }
      }
    } catch (error: any) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: error.rawMessage
            ? error.rawMessage?.replace(/.*\]\s*/, '').trim()
            : error.message
            ? error.message.replace(/.*\]\s*/, '').trim()
            : 'Error occurred while uploading assessment',
          open: true,
        })
      );
      setOmrScanFile([]);
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------

  const getClassScore = () => {
    if (
      current_assessmemt_classStats?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      return Math.round(Number(omrClassStats?.classScore?.toFixed(2))) || 0;
    }
    return (
      Math.round(
        Number(
          current_assessmemt_classStats?.assessment?.classScore?.toFixed(2)
        )
      ) || 0
    );
  };

  // -----------------------------------------------------

  const handleSectionChange = () => {};

  const backButtonClick = async () => {
    await aiHomeworkCloseEvent({
      homeworkId: selected_assessment_id,
      isOffline: isOffline,
    });
    const from = location.state?.from;
    if (from === '/home') {
      navigate(HOME);
    } else {
      navigate(HOMEWORK_MANAGE);
    }
  };

  // -----------------------------------------------------

  useEffect(() => {
    setSelectedFunction(() => backButtonClick);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  useEffect(() => {
    if (selected_assessment_id) {
      fetchAssessmentContent();
      getHomeworkDetails(selected_assessment_id);
      const assmnt = assessment_list_data?.assigned.find(
        (e) => e.assessmentId === selected_assessment_id
      );
      setCurrentHomwork(assmnt);
    }
  }, []);

  // -----------------------------------------------------

  // Web Live Quiz reuses this exact page/components rather than a dedicated
  // page (matching how OMR mode is special-cased inline, not routed
  // elsewhere) — HwDetails and StudentSection (incl. its
  // cardOnClickHandler-driven student click-through) stay identical to
  // every other mode. HwDetails itself renders the live quiz's Start
  // trigger at the top of the left column — the same position Clicker's
  // ConnectedClassStartBox occupies on its own manage page — rather than
  // this component swapping anything out. The one other Clicker-matched
  // detail: Clicker's page shows "View Assessment" as a small button inside
  // an OverviewBox card atop the right column (Test Overview), not the
  // header's own big button — so Live Quiz mode swaps to that same
  // presentation instead.
  const isLiveQuizMode =
    current_assessmemt_classStats?.assessment?.modeOfConduction ===
    ModeOfConductionEnum.MODE_OF_CONDUCTION_WEB_LIVE;

  // Live Quiz can only ever be started between its start and end time — once
  // the deadline passes there's nothing left to "start", so this page isn't
  // the right one to sit on any more. Mirrors ClickerAssessmentManage's own
  // isTimeLeft(assessmentTargetDate) check (the same field, same utility)
  // which sends an ended Clicker assessment to its dedicated Ended view
  // instead of leaving it on the Ongoing/Start screen — Live Quiz isn't
  // Clicker, so its equivalent "ended" destination is the same
  // HOMEWORK_COMPLETED page regular (non-clicker) homework already uses once
  // ended, not a Live-Quiz-specific page.

  const assessmentTargetDate =
    current_assessmemt_classStats?.assessment?.assessmentTargetDate;
  const targetSeconds = assessmentTargetDate?.seconds;
  const targetNanos = assessmentTargetDate?.nanos;
  useEffect(() => {
    if (
      isLiveQuizMode &&
      current_assessmemt_classStats?.assessment?.assessmentTargetDate &&
      !isTimeLeft(
        new Timestamp(
          // current_assessmemt_classStats.assessment.assessmentTargetDate
          { seconds: targetSeconds, nanos: targetNanos ?? 0 }
        )
      )
    ) {
      navigate(HOMEWORK_COMPLETED, { replace: true });
    }
  }, [isLiveQuizMode, targetSeconds, targetNanos]);

  return loading === true ? (
    <Loader />
  ) : error === true ? (
    <Typography>Error Occured</Typography>
  ) : (
    <Box sx={styles.root}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: pxToRem(10), md: pxTovW(22) },
          padding: {
            xs: `${pxToRem(23)} ${pxToRem(20)}`,
            md: `${pxTovW(25)} 0`,
          },
          // backgroundColor: 'red',
        }}
      >
        <Box sx={styles.header}>
          <ImageWrapper
            name="chapterImage"
            type="png"
            parentFolder="tempAssets"
            path={getMediaBasePath(
              current_assessmemt_classStats?.assessment?.assessmentPosterImgUrl,
              'processedMediaBucket'
            )}
            styles={styles.headImage}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              // height: { xs: pxToRem(74), md: pxTovW(120) },
              boxSizing: 'border-box',
              gap: { xs: pxToRem(14), md: pxTovW(16) },
              // justifyContent: 'space-between',
              width: '100%',
              // backgroundColor: 'red',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: { xs: pxToRem(250), md: pxTovW(790) },
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordWrap: 'break-word',
                }}
              >
                {current_assessmemt_classStats?.assessment?.assessmentTitle ||
                  'title'}
              </Typography>
              <Typography
                variant={isIpadOnly ? 'h4' : 'button'}
                color="primary"
                fontWeight="regular"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  width: '90%',
                }}
              >
                {subtitleParts}
              </Typography>
            </Box>
            <Box sx={{ width: { xs: pxToRem(178), md: pxTovW(300) } }}>
              {current_assessmemt_classStats?.assessment?.maxMarks !==
                undefined && (
                <ScoreProgressBar
                  variant={largeScreen ? 'lg' : 'md'}
                  score={getClassScore()}
                />
              )}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: '90%', md: pxToRem(300), lg: 'max-content' },
            display: {
              xs:
                !isLiveQuizMode &&
                current_assessmemt_classStats?.assessment?.submissionType
                  ? 'flex'
                  : 'none',
              md: isLiveQuizMode ? 'none' : 'block',
            },
            margin: { xs: 'auto', md: 'unset' },
            marginBottom: 'auto',
          }}
        >
          <PrimaryButton
            fullWidth={isIpadOnly ? true : false}
            onClick={async () => {
              navigate(`${ASSESSMENT_VIEW}/assigned`);
              await interactionEvent({
                context: 'homework',
                name: 'VIEW_HOMEWORK',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });
            }}
          >
            <Typography variant="h3" color="#FFFFFF" fontWeight={600}>
              View Assessment
            </Typography>
          </PrimaryButton>
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: '100vw', md: '100%' },
          // backgroundColor: 'red',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { lg: pxTovW(40) },
        }}
      >
        <HwDetails
          assessmentContent={assessmentContent}
          currentHomework={current_assessmemt_classStats?.assessment}
          assigendInfo={getAssignedStudentsCount()}
          submissonCount={getStudentsSubmissionCount()}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: pxToRem(20), md: pxTovW(34) },
            flex: 1,
          }}
        >
          {isLiveQuizMode && (
            // Matches CAOngoingHwRightPanel exactly: Test Overview card atop
            // the right column, its own small "View Assessment" button —
            // desktop-only there too, so mirrored here (mobile keeps nothing
            // in this slot for live quiz, same as Clicker's own page).
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <OverviewBox
                assessmentTargetDate={
                  current_assessmemt_classStats?.assessment
                    ?.assessmentTargetDate
                }
                difficultyLevel={
                  current_assessmemt_classStats?.assessment?.difficultyLevel
                }
                numberOfQuestions={
                  current_assessmemt_classStats?.assessment
                    ?.assessmentContentInfo?.numberOfQuestions
                }
                viewAssessmentCTA={async () => {
                  navigate(`${ASSESSMENT_VIEW}/assigned`);
                  await interactionEvent({
                    context: 'Test_Overview',
                    name: 'VIEW_ASSESSMENT',
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }}
              />
            </Box>
          )}
          {getStudentPerformanceInfoList()?.length ? (
            <StudentSection
              Class={`${current_assessmemt_classStats?.assessment?.class}${current_assessmemt_classStats?.assessment?.section}`}
              studentPerformanceInfoList={getStudentPerformanceInfoList()}
              cardMaxMarks={current_assessmemt_classStats?.assessment?.maxMarks}
              cardSubmissionType={
                current_assessmemt_classStats?.assessment?.submissionType
              }
              cardOnClickHandler={cardOnClick}
              checkBoxClickHandler={physicalHwSubmitHandler}
              statusInfo={StatusObject}
              // saveStudentInfo={setStudentInfo}
              textClickHandler={marksTextClickHandler}
              modeOfConduction={
                current_assessmemt_classStats?.assessment?.modeOfConduction
              }
              assessmentName={
                current_assessmemt_classStats?.assessment?.assessmentTitle
              }
              reportSubject={
                current_assessmemt_classStats?.assessment?.subjects?.length
                  ? current_assessmemt_classStats.assessment.subjects.join('_')
                  : current_assessmemt_classStats?.assessment?.subject
              }
              reportClassName={current_assessmemt_classStats?.assessment?.class}
              reportSection={current_assessmemt_classStats?.assessment?.section}
              setOpenOmrUploadPopup={setOpenOmrUploadPopup}
              onMarkAttendanceClick={
                isAttendanceFeatureEnabled &&
                current_assessmemt_classStats?.assessment?.assignmentInfo?.find(
                  (val) =>
                    val.configName ===
                    AssignmentConfigEnum.ASSIGNMENT_CONFIG_ATTENDANCE
                )?.isEnabled
                  ? () => {
                      setStudentListPopupOpen(true);
                    }
                  : undefined
              }
            />
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: pxToRem(10), md: pxTovW(20) },
                alignItems: 'center',
                paddingLeft: { xs: pxToRem(0), md: pxTovW(40) },
                marginLeft: { xs: 'unset', md: 'auto', lg: 'auto' },
                marginTop: { xs: pxToRem(20), md: pxTovW(0) },
              }}
            >
              {current_assessmemt_classStats?.assessment?.modeOfConduction ===
                ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR && (
                <Button
                  startIcon={
                    <IconWrapper
                      name="scan-white"
                      type="png"
                      parentFolder="icons"
                      size="md"
                    />
                  }
                  onClick={() => setOpenOmrUploadPopup(true)}
                  sx={{
                    backgroundColor: '#0AA34F',
                    padding: { xs: pxToRem(10), md: pxTovW(10) },
                    '&:hover': {
                      backgroundColor: 'success.main',
                    },
                  }}
                >
                  <Typography variant="h4" color="white">
                    Scan Student Answer Sheet
                  </Typography>
                </Button>
              )}

              <NoContentCard
                variant="info"
                icon="cards"
                text="Student Performance Data Not Available"
              />
            </Box>
          )}
        </Box>

        {/* <StudentSection
          Class={`${current_assessmemt_classStats?.assessment?.class}${current_assessmemt_classStats?.assessment?.section}`}
          studentPerformanceInfoList={
            getStudentPerformanceInfoList()
          }
          cardMaxMarks={current_assessmemt_classStats?.assessment?.maxMarks}
          cardSubmissionType={
            current_assessmemt_classStats?.assessment?.submissionType
          }
          cardOnClickHandler={cardOnClick}
          checkBoxClickHandler={physicalHwSubmitHandler}
          statusInfo={StatusObject}
          // saveStudentInfo={setStudentInfo}
          textClickHandler={marksTextClickHandler}
        /> */}
      </Box>

      <MarksSubmitPopup
        open={marksPopupDisplay}
        totalMarks={current_assessmemt_classStats?.assessment?.maxMarks || 0}
        handleClose={() => {
          setMarksPopupDisplay(false);
          setStudentInfo(undefined);
        }}
        submitClickHandler={physicalHwSubmitHandler}
      />

      <OmrUploadPopup
        open={openOmrUploadPopup}
        handleClose={() => setOpenOmrUploadPopup(false)}
        handleDropFunction={handleDropFunction}
        handleChangeFunction={handleChangeFunction}
        handleDeleteFunction={handleDeleteFunction}
        userUploads={omrScanFile ?? []}
        isUploading={loading}
      />

      <StudentListPopup
        open={studentListPopupOpen}
        handleClose={() => setStudentListPopupOpen(false)}
        sectionList={sectionList}
        setSectionList={setSectionList}
        handleSectionChange={handleSectionChange}
        sectionStudentInfo={sectionStudentInfo}
        setSectionStudentInfo={setSectionStudentInfo}
        assessmentId={selected_assessment_id}
        useAttendanceApi={true}
        onCloseAction={() => {}}
        onSubmitAction={markAttendanceOnClose}
      />
    </Box>
  );
};
